var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.6,25.9v32.9c77.3,6.3,139.1,72.3,143.7,149.2,3,50.1-3.5,103.9,0,153.7,1.5,22.3,18.6,33.4,40,31.4v31.9h-154.7c9.7,25.4-5.1,54.9-31.2,62.1-38.6,10.7-71.7-24.6-58.6-62.1H49v-31.9c21.3,2.1,38.4-9.2,40-31.4,3.4-49.8-3-103.6,0-153.7,4.6-77,66.4-142.7,143.7-149.2V25.9h31.9ZM385.3,393.2c-4.6-8.4-8.3-17.8-9-27.4-7-89.1,29.8-205.8-64.2-259.2-81.8-46.5-185.2,8.9-191.3,102.5-3.3,50.6,3.7,105.4,0,155.7s-4.1,19.7-9,28.4h273.5ZM245.4,425.4c-19.2,3.1-15.9,35.1,6.5,31.5,19.2-3.1,15.9-35.1-6.5-31.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.4,425.4c22.5-3.6,25.7,28.3,6.5,31.5-22.5,3.6-25.7-28.3-6.5-31.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.46251a1f95ccf939a15b9315fdbf57a3.svg";
export { ForwardRef as ReactComponent };